import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from 'src/app/services/core/authentication/authentication.service';
import { ConfigurationSettings } from 'src/app/models/configuration.settings';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
    token:string;
    constructor(private authenticationService: AuthenticationService, private configurationSettings: ConfigurationSettings) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //add authorization header with jwt token if available
        if(this.configurationSettings.hilUrl && request.url.toLowerCase().startsWith(this.configurationSettings.hilUrl.toLowerCase()))
        {
            this.token = localStorage.getItem('accessToken');
        }
        else
        {
            this.token = sessionStorage.getItem('access_token');
        }       
        if (this.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.token}`
                }
            });
        }
        return next.handle(request);
    }
}